// Auto-generated from gen_hunt_data.ts
// DO NOT EDIT THIS FILE DIRECTLY

import { LocaleObject } from '../types/trigger';

type LocaleTextOrArray = LocaleObject<string | string[]>;

export type Rank = 'S' | 'SS+' | 'SS-' | 'A' | 'B';

// Optional values are supported in `Options.CustomMonsters`.
export type HuntEntry = {
  id: string;
  name: LocaleTextOrArray | string | string[];
  rank?: Rank;
  regex?: RegExp;
  hp?: number;
};

export type HuntMap = {
  [huntName: string]: HuntEntry;
};

const data: HuntMap = {
  '13th Child': {
    'id': '13155',
    'name': {
      'cn': '第十三个孩子',
      'de': [
        'Dreizehnte Kind',
        'Dreizehnter Kind',
        'Dreizehntes Kind',
      ],
      'en': '13th Child',
      'fr': 'treizième enfant',
      'ja': 'サーティーンス・チャイルド',
      'ko': '열셋째 아이',
      'tc': '第十三個孩子',
    },
    'rank': 'B',
  },
  'Aegeiros': {
    'id': '10628',
    'name': {
      'cn': '黑杨树精',
      'de': 'Aegeiros',
      'en': 'Aegeiros',
      'fr': 'ægeiros',
      'ja': 'アイゲイロス',
      'ko': '아이게이로스',
      'tc': '黑楊樹妖',
    },
    'rank': 'A',
  },
  'Agathos': {
    'id': '4369',
    'name': {
      'cn': '阿伽托斯',
      'de': 'Agathos',
      'en': 'Agathos',
      'fr': 'Agathos',
      'ja': 'アガトス',
      'ko': '아가토스',
      'tc': '阿伽托斯',
    },
    'rank': 'A',
  },
  'Aglaope': {
    'id': '8653',
    'name': {
      'cn': '阿格拉俄珀',
      'de': 'Aglaope',
      'en': 'Aglaope',
      'fr': 'Aglaope',
      'ja': 'アグラオペ',
      'ko': '아글라오페',
      'tc': '阿格拉俄珀',
    },
    'rank': 'S',
  },
  'Agrippa the Mighty': {
    'id': '2969',
    'name': {
      'cn': '阿格里帕',
      'de': 'Agrippa',
      'en': 'Agrippa the Mighty',
      'fr': 'Agrippa',
      'ja': 'アグリッパ',
      'ko': '아그리파',
      'tc': '阿格里帕',
    },
    'rank': 'S',
  },
  'Albin the Ashen': {
    'id': '2926',
    'name': {
      'cn': '死灰复燃的阿尔宾',
      'de': 'Albin Aschfahl',
      'en': 'Albin the Ashen',
      'fr': 'Albin le blafard',
      'ja': '死灰のアルビン',
      'ko': '잿빛낯 알빈',
      'tc': '死灰復燃的阿爾賓',
    },
    'rank': 'B',
  },
  'Alectryon': {
    'id': '2940',
    'name': {
      'cn': '阿列刻特利昂',
      'de': 'Alectryon',
      'en': 'Alectryon',
      'fr': 'Alectryon',
      'ja': 'アレクトリオン',
      'ko': '알렉트리온',
      'tc': '阿列刻特利昂',
    },
    'rank': 'A',
  },
  'Alteci': {
    'id': '4350',
    'name': {
      'cn': '阿尔提克',
      'de': 'Artic',
      'en': 'Alteci',
      'fr': 'Altek',
      'ja': 'アルティック',
      'ko': '알티크',
      'tc': '阿提克',
    },
    'rank': 'B',
  },
  'Angada': {
    'id': '5999',
    'name': {
      'cn': '安迦达',
      'de': 'Angada',
      'en': 'Angada',
      'fr': 'Angada',
      'ja': 'アンガダ',
      'ko': '앙가다',
      'tc': '安迦達',
    },
    'rank': 'A',
  },
  'Aqrabuamelu': {
    'id': '5993',
    'name': {
      'cn': '熔骨炎蝎',
      'de': 'Aqrabuamelu',
      'en': 'Aqrabuamelu',
      'fr': 'Aqrabuamelu',
      'ja': 'アクラブアメル',
      'ko': '아크라부아멜루',
      'tc': '熔骨炎蠍',
    },
    'rank': 'A',
  },
  'Arch-Eta': {
    'id': '10634',
    'name': {
      'cn': '伊塔总领',
      'de': 'Erz-Eta',
      'en': 'Arch-Eta',
      'fr': 'Arch-Êta',
      'ja': 'アーチイータ',
      'ko': '아치 에타',
      'tc': '伊塔總領',
    },
    'rank': 'A',
  },
  'Armstrong': {
    'id': '10619',
    'name': {
      'cn': '阿姆斯特朗',
      'de': 'Armstrong',
      'en': 'Armstrong',
      'fr': 'Armstrong',
      'ja': 'アームストロング',
      'ko': '암스트롱',
      'tc': '阿姆斯壯',
    },
    'rank': 'S',
  },
  'Aswang': {
    'id': '6007',
    'name': {
      'cn': '阿苏黄',
      'de': 'Aswang',
      'en': 'Aswang',
      'fr': 'Aswang',
      'ja': 'アスワング',
      'ko': '아스왕',
      'tc': '阿蘇黃',
    },
    'rank': 'B',
  },
  'Atticus the Primogenitor': {
    'id': '13156',
    'name': {
      'cn': '先驱勇士 阿提卡斯',
      'de': [
        'Atticus der Primogenitor',
        'Atticus die Primogenitor',
        'Atticus das Primogenitor',
      ],
      'en': 'Atticus the Primogenitor',
      'fr': 'Atticus le primogéniteur',
      'ja': '先駆けのアティカス',
      'ko': '선구자 아티커스',
      'tc': '先驅勇士 阿提卡斯',
    },
    'rank': 'S',
  },
  'Baal': {
    'id': '8897',
    'name': {
      'cn': '巴力',
      'de': 'Baal',
      'en': 'Baal',
      'fr': 'Baal',
      'ja': 'バール',
      'ko': '바알',
      'tc': '巴力',
    },
    'rank': 'A',
  },
  'Barbastelle': {
    'id': '2929',
    'name': {
      'cn': '宽耳凶蝠',
      'de': 'Barbastelle',
      'en': 'Barbastelle',
      'fr': 'Barbastelle',
      'ja': 'バーバステル',
      'ko': '바바스텔',
      'tc': '寬耳凶蝠',
    },
    'rank': 'B',
  },
  'Bird of Paradise': {
    'id': '4378',
    'name': {
      'cn': '极乐鸟',
      'de': 'Paradiesvogel',
      'en': 'Bird of Paradise',
      'fr': 'oiseau de Paradis',
      'ja': '極楽鳥',
      'ko': '극락조',
      'tc': '極樂鳥',
    },
    'rank': 'S',
  },
  'Bloody Mary': {
    'id': '2930',
    'name': {
      'cn': '血腥玛丽',
      'de': 'Bloody Mary',
      'en': 'Bloody Mary',
      'fr': 'Mary la sanglante',
      'ja': 'ブラッディ・マリー',
      'ko': '핏빛 메리',
      'tc': '血腥瑪麗',
    },
    'rank': 'B',
  },
  'Bone Crawler': {
    'id': '5988',
    'name': {
      'cn': '爬骨怪龙',
      'de': 'Knochenkriecher',
      'en': 'Bone Crawler',
      'fr': 'Mangeur d\'os',
      'ja': 'ボーンクローラー',
      'ko': '해골거미',
      'tc': '爬骨怪龍',
    },
    'rank': 'S',
  },
  'Bonnacon': {
    'id': '2965',
    'name': {
      'cn': '火愤牛',
      'de': 'Bonnacon',
      'en': 'Bonnacon',
      'fr': 'Bonnacon',
      'ja': 'ボナコン',
      'ko': '보나콘',
      'tc': '火憤牛',
    },
    'rank': 'S',
  },
  'Brontes': {
    'id': '2958',
    'name': {
      'cn': '布隆特斯',
      'de': 'Brontes',
      'en': 'Brontes',
      'fr': 'Brontes',
      'ja': 'ブロンテス',
      'ko': '브론테스',
      'tc': '布隆特斯',
    },
    'rank': 'S',
  },
  'Buccaboo': {
    'id': '6011',
    'name': {
      'cn': '布卡卜',
      'de': 'Buccaboo',
      'en': 'Buccaboo',
      'fr': 'Bucca-boo',
      'ja': 'ブッカブー',
      'ko': '부카부',
      'tc': '布卡蔔',
    },
    'rank': 'B',
  },
  'Bune': {
    'id': '4368',
    'name': {
      'cn': '布涅',
      'de': 'Bune',
      'en': 'Bune',
      'fr': 'Bune',
      'ja': 'ブネ',
      'ko': '부네',
      'tc': '布涅',
    },
    'rank': 'A',
  },
  'Burfurlur the Canny': {
    'id': '10617',
    'name': {
      'cn': '布弗鲁',
      'de': [
        'Burfurlur der Gerissene',
        'Burfurlur der Gerissener',
        'Burfurlur der Gerissenes',
        'Burfurlur die Gerissene',
        'Burfurlur die Gerissener',
        'Burfurlur die Gerissenes',
        'Burfurlur das Gerissene',
        'Burfurlur das Gerissener',
        'Burfurlur das Gerissenes',
      ],
      'en': 'Burfurlur the Canny',
      'fr': 'Burfurlur',
      'ja': 'ブーフールー',
      'ko': '부푸루',
      'tc': '布弗魯',
    },
    'rank': 'S',
  },
  'Campacti': {
    'id': '4372',
    'name': {
      'cn': '坎帕提',
      'de': 'Campacti',
      'en': 'Campacti',
      'fr': 'Campacti',
      'ja': 'キャムパクティ',
      'ko': '캠파크티',
      'tc': '坎帕提',
    },
    'rank': 'A',
  },
  'Cat\'s Eye': {
    'id': '13436',
    'name': {
      'cn': '猫眼',
      'de': 'Katzenauge',
      'en': 'Cat\'s Eye',
      'fr': 'Œil-de-chat',
      'ja': 'キャッツアイ',
      'ko': '캣츠아이',
      'tc': '貓眼',
    },
    'rank': 'A',
  },
  'Chernobog': {
    'id': '2967',
    'name': {
      'cn': '牛头黑神',
      'de': 'Czernobog',
      'en': 'Chernobog',
      'fr': 'Czernobog',
      'ja': 'チェルノボーグ',
      'ko': '체르노보그',
      'tc': '牛頭黑神',
    },
    'rank': 'S',
  },
  'Chupacabra': {
    'id': '13145',
    'name': {
      'cn': '卓伯卡布拉',
      'de': 'Chupacabra',
      'en': 'Chupacabra',
      'fr': 'chupacabra',
      'ja': 'チュパカブラ',
      'ko': '추파카브라',
      'tc': '卓伯卡布拉',
    },
    'rank': 'B',
  },
  'Coquecigrue': {
    'id': '8913',
    'name': {
      'cn': '三合鸟儿',
      'de': 'Coquecigrue',
      'en': 'Coquecigrue',
      'fr': 'Coquecigrue',
      'ja': 'コクシグルー',
      'ko': '콕시그뤼',
      'tc': '三合鳥兒',
    },
    'rank': 'B',
  },
  'Cornu': {
    'id': '2950',
    'name': {
      'cn': '角祖',
      'de': 'Cornu',
      'en': 'Cornu',
      'fr': 'Cornu',
      'ja': 'コンヌ',
      'ko': '콘누',
      'tc': '角祖',
    },
    'rank': 'A',
  },
  'Croakadile': {
    'id': '2963',
    'name': {
      'cn': '咕尔呱洛斯',
      'de': 'Quakquak',
      'en': 'Croakadile',
      'fr': 'Croabéros',
      'ja': 'ケロゲロス',
      'ko': '개굴개로스',
      'tc': '凱羅葛洛斯',
    },
    'rank': 'S',
  },
  'Croque-mitaine': {
    'id': '2962',
    'name': {
      'cn': '护土精灵',
      'de': 'Croque Mitaine',
      'en': 'Croque-mitaine',
      'fr': 'Croque-mitaine',
      'ja': 'クロック・ミテーヌ',
      'ko': '크로크 미테느',
      'tc': '護土精靈',
    },
    'rank': 'S',
  },
  'Dalvag\'s Final Flame': {
    'id': '2944',
    'name': {
      'cn': '菲兰德的遗火',
      'de': [
        'Letzte Flamme Dalvags',
        'Letzter Flamme Dalvags',
        'Letztes Flamme Dalvags',
      ],
      'en': 'Dalvag\'s Final Flame',
      'fr': 'dernière flamme de Dalvag',
      'ja': 'ファイナルフレイム',
      'ko': '마지막 투혼',
      'tc': '菲蘭德的遺火',
    },
    'rank': 'A',
  },
  'Dark Helmet': {
    'id': '2931',
    'name': {
      'cn': '暗盔魔蟹',
      'de': 'Dunkelhelm',
      'en': 'Dark Helmet',
      'fr': 'Casque noir',
      'ja': 'ダークヘルメット',
      'ko': '검은 투구게',
      'tc': '暗盔魔蟹',
    },
    'rank': 'B',
  },
  'Deacon': {
    'id': '8899',
    'name': {
      'cn': '助祭大蟹',
      'de': 'Diakon',
      'en': 'Deacon',
      'fr': 'Diacre',
      'ja': 'ディーコン',
      'ko': '부사제게',
      'tc': '助祭大蟹',
    },
    'rank': 'B',
  },
  'Deidar': {
    'id': '6004',
    'name': {
      'cn': '大太',
      'de': 'Deidar',
      'en': 'Deidar',
      'fr': 'Deidar',
      'ja': 'デイダラ',
      'ko': '데이다라',
      'tc': '大太',
    },
    'rank': 'B',
  },
  'Domovoi': {
    'id': '8656',
    'name': {
      'cn': '杜莫伊',
      'de': 'Domovoi',
      'en': 'Domovoi',
      'fr': 'Domovoï',
      'ja': 'ドモヴォーイ',
      'ko': '도모보이',
      'tc': '杜莫伊',
    },
    'rank': 'B',
  },
  'Emperor\'s rose': {
    'id': '10640',
    'name': {
      'cn': '皇帝的玫瑰',
      'de': 'Rose des Kaisers',
      'en': 'Emperor\'s rose',
      'fr': 'rosier de l\'empereur',
      'ja': 'エンペラーズローズ',
      'ko': '황제의 장미',
      'tc': '皇帝的玫瑰',
    },
    'rank': 'B',
  },
  'Enkelados': {
    'id': '4370',
    'name': {
      'cn': '恩克拉多斯',
      'de': 'Engedoras',
      'en': 'Enkelados',
      'fr': 'Enkélados',
      'ja': 'エンケドラス',
      'ko': '엔켈라도스',
      'tc': '恩克拉多斯',
    },
    'rank': 'A',
  },
  'Erle': {
    'id': '5991',
    'name': {
      'cn': '女王蜂',
      'de': 'Erle',
      'en': 'Erle',
      'fr': 'Erle',
      'ja': 'アール',
      'ko': '얼',
      'tc': '女王蜂',
    },
    'rank': 'A',
  },
  'Fan Ail': {
    'id': '10633',
    'name': {
      'cn': '凡·艾尔',
      'de': 'Fan Ail',
      'en': 'Fan Ail',
      'fr': 'Fan Ail',
      'ja': 'ファン・アイル',
      'ko': '판 아일',
      'tc': '凡·艾爾',
    },
    'rank': 'A',
  },
  'Flame Sergeant Dalvag': {
    'id': '2927',
    'name': {
      'cn': '永恒不灭的菲兰德副耀士',
      'de': 'Dalvag',
      'en': 'Flame Sergeant Dalvag',
      'fr': 'sergent-major Dalvag',
      'ja': '不滅のフェランド闘軍曹',
      'ko': '불멸의 중사 페란드',
      'tc': '不滅的菲蘭德鬥軍曹',
    },
    'rank': 'B',
  },
  'Forneus': {
    'id': '2936',
    'name': {
      'cn': '弗内乌斯',
      'de': 'Forneus',
      'en': 'Forneus',
      'fr': 'Forneus',
      'ja': 'ファルネウス',
      'ko': '포르네우스',
      'tc': '弗內烏斯',
    },
    'rank': 'A',
  },
  'Funa Yurei': {
    'id': '5996',
    'name': {
      'cn': '船幽灵',
      'de': 'Funa Yurei',
      'en': 'Funa Yurei',
      'fr': 'Funa Yurei',
      'ja': '船幽霊',
      'ko': '선박 유령',
      'tc': '船幽靈',
    },
    'rank': 'A',
  },
  'Gajasura': {
    'id': '5998',
    'name': {
      'cn': '象魔修罗',
      'de': 'Gajasura',
      'en': 'Gajasura',
      'fr': 'Gajasura',
      'ja': 'ガジャースラ',
      'ko': '가자수라',
      'tc': '象魔修羅',
    },
    'rank': 'A',
  },
  'Gallowsbeak': {
    'id': '13152',
    'name': {
      'cn': '斩首魔鸟',
      'de': 'Galgenschnabel',
      'en': 'Gallowsbeak',
      'fr': 'Gibec',
      'ja': 'ギャロウズビーク',
      'ko': '교수대부리',
      'tc': '斬首魔鳥',
    },
    'rank': 'B',
  },
  'Gamma': {
    'id': '5985',
    'name': {
      'cn': '伽马',
      'de': 'Gamma',
      'en': 'Gamma',
      'fr': 'Gamma',
      'ja': 'ガンマ',
      'ko': '감마',
      'tc': '伽馬',
    },
    'rank': 'S',
  },
  'Gandarewa': {
    'id': '4377',
    'name': {
      'cn': '刚德瑞瓦',
      'de': 'Gandalva',
      'en': 'Gandarewa',
      'fr': 'Gandharva',
      'ja': 'ガンダルヴァ',
      'ko': '간다르바',
      'tc': '乾闥婆',
    },
    'rank': 'S',
  },
  'Gatling': {
    'id': '2925',
    'name': {
      'cn': '加特林针鼹',
      'de': 'Gatling',
      'en': 'Gatling',
      'fr': 'Acanthor',
      'ja': 'ガトリングス',
      'ko': '개틀링',
      'tc': '加特林針鼴',
    },
    'rank': 'B',
  },
  'Gauki Strongblade': {
    'id': '6002',
    'name': {
      'cn': '剑豪 刑具',
      'de': 'Gauki Starkklinge',
      'en': 'Gauki Strongblade',
      'fr': 'Gauki la Lame forte',
      'ja': '剣豪ガウキ',
      'ko': '검호 가우키',
      'tc': '劍豪 刑具',
    },
    'rank': 'B',
  },
  'Ghede Ti Malice': {
    'id': '2938',
    'name': {
      'cn': '盖得',
      'de': 'Ghede Titus Häme',
      'en': 'Ghede Ti Malice',
      'fr': 'Guédé Ti-Malice',
      'ja': 'ゲーデ',
      'ko': '게데',
      'tc': '蓋得',
    },
    'rank': 'A',
  },
  'Gilshs Aath Swiftclaw': {
    'id': '8898',
    'name': {
      'cn': '徒手抓鱼 基乌嘶·渊斯',
      'de': 'Gilshs Aath',
      'en': 'Gilshs Aath Swiftclaw',
      'fr': 'Gilshs Aath l\'étrangleur',
      'ja': '手掴のギウスィー・アース',
      'ko': '맨손의 기우쉬 아스',
      'tc': '徒手抓魚 基烏嘶·淵斯',
    },
    'rank': 'B',
  },
  'Girimekhala': {
    'id': '6000',
    'name': {
      'cn': '基里麦卡拉',
      'de': 'Girimekhala',
      'en': 'Girimekhala',
      'fr': 'Girimekhala',
      'ja': 'ギリメカラ',
      'ko': '기리메칼라',
      'tc': '基里麥卡拉',
    },
    'rank': 'A',
  },
  'Girtab': {
    'id': '2939',
    'name': {
      'cn': '尾宿蛛蝎',
      'de': 'Girtab',
      'en': 'Girtab',
      'fr': 'Girtab',
      'ja': 'ギルタブ',
      'ko': '기르타브',
      'tc': '尾宿蛛蠍',
    },
    'rank': 'A',
  },
  'Gnath cometdrone': {
    'id': '4352',
    'name': {
      'cn': '骨颌彗星兵',
      'de': 'Gnath-Kometdrohne',
      'en': 'Gnath cometdrone',
      'fr': 'Gnathe myrmicomète',
      'ja': 'グナース・コメットドローン',
      'ko': '그나스 혜성요격자',
      'tc': '骨頜彗星兵',
    },
    'rank': 'B',
  },
  'Grassman': {
    'id': '8892',
    'name': {
      'cn': '格拉斯曼',
      'de': 'Grasmann',
      'en': 'Grassman',
      'fr': 'Sasquatch arboricole',
      'ja': 'グラスマン',
      'ko': '숲원인',
      'tc': '格拉斯曼',
    },
    'rank': 'A',
  },
  'Guhuo Niao': {
    'id': '6003',
    'name': {
      'cn': '姑获鸟',
      'de': 'Guhuo Niao',
      'en': 'Guhuo Niao',
      'fr': 'Guhuo Niao',
      'ja': '姑獲鳥',
      'ko': '우부메',
      'tc': '姑獲鳥',
    },
    'rank': 'B',
  },
  'Gunitt': {
    'id': '8895',
    'name': {
      'cn': '顾尼图',
      'de': 'Gunitt',
      'en': 'Gunitt',
      'fr': 'Gunitt',
      'ja': 'グニット',
      'ko': '구니트',
      'tc': '顧尼圖',
    },
    'rank': 'S',
  },
  'Gurangatch': {
    'id': '10631',
    'name': {
      'cn': '固兰盖奇',
      'de': 'Gurangatch',
      'en': 'Gurangatch',
      'fr': 'Gurangatch',
      'ja': 'グランガチ',
      'ko': '구랑가치',
      'tc': '固蘭蓋奇',
    },
    'rank': 'A',
  },
  'Gwas-y-neidr': {
    'id': '6010',
    'name': {
      'cn': '蛇仆蚂蜓',
      'de': 'Gwas-y-neidr',
      'en': 'Gwas-y-neidr',
      'fr': 'Gwas-y-neidr',
      'ja': 'グアス・ア・ニードル',
      'ko': '독사의 종복',
      'tc': '蛇僕螞蜓',
    },
    'rank': 'B',
  },
  'Gyorai Quickstrike': {
    'id': '6005',
    'name': {
      'cn': '闪雷击 鱼雷',
      'de': 'Gyorai Schnellschlag',
      'en': 'Gyorai Quickstrike',
      'fr': 'Gyorai le Vif',
      'ja': '雷撃のギョライ',
      'ko': '뇌격의 교라이',
      'tc': '閃雷擊 魚雷',
    },
    'rank': 'B',
  },
  'Hellsclaw': {
    'id': '2947',
    'name': {
      'cn': '魔导地狱爪',
      'de': 'Höllenklaue',
      'en': 'Hellsclaw',
      'fr': 'griffe des enfers magitek',
      'ja': '魔導ヘルズクロー',
      'ko': '마도 지옥손아귀',
      'tc': '魔導地獄爪',
    },
    'rank': 'A',
  },
  'Huracan': {
    'id': '8912',
    'name': {
      'cn': '乌拉坎',
      'de': 'Huracan',
      'en': 'Huracan',
      'fr': 'Huracan',
      'ja': 'フラカン',
      'ko': '후라칸',
      'tc': '烏拉坎',
    },
    'rank': 'A',
  },
  'Ihnuxokiy': {
    'id': '13444',
    'name': {
      'cn': '伊努索奇',
      'de': 'Ihnuxokiy',
      'en': 'Ihnuxokiy',
      'fr': 'Ihnuxokiy',
      'ja': 'イヌショキー',
      'ko': '이누쇼키',
      'tc': '伊努索奇',
    },
    'rank': 'S',
  },
  'Indomitable': {
    'id': '8914',
    'name': {
      'cn': '不屈号',
      'de': 'Unbezähmbar',
      'en': 'Indomitable',
      'fr': 'Indomptable',
      'ja': 'インドミタブル',
      'ko': '깡다구',
      'tc': '不屈號',
    },
    'rank': 'B',
  },
  'Iravati': {
    'id': '10638',
    'name': {
      'cn': '伊罗婆缇',
      'de': 'Iravati',
      'en': 'Iravati',
      'fr': 'Iravati',
      'ja': 'イラーヴァティ',
      'ko': '이라바티',
      'tc': '伊羅婆緹',
    },
    'rank': 'B',
  },
  'Itzpapalotl': {
    'id': '8909',
    'name': {
      'cn': '伊兹帕帕洛特尔',
      'de': 'Itzpapalotl',
      'en': 'Itzpapalotl',
      'fr': 'Itzpapalotl',
      'ja': 'イツパパロツル',
      'ko': '이츠파팔로틀',
      'tc': '伊茲帕帕洛特爾',
    },
    'rank': 'B',
  },
  'Ixtab': {
    'id': '8890',
    'name': {
      'cn': '伊休妲',
      'de': 'Ixtab',
      'en': 'Ixtab',
      'fr': 'Ixtab',
      'ja': 'イシュタム',
      'ko': '이쉬타브',
      'tc': '伊休妲',
    },
    'rank': 'S',
  },
  'Juggler Hecatomb': {
    'id': '8904',
    'name': {
      'cn': '残虐杂技师',
      'de': 'Gaukler Hecatomb',
      'en': 'Juggler Hecatomb',
      'fr': 'Jongleur hécatombe',
      'ja': 'ジャグラー・ヘカトゥーム',
      'ko': '학살 곡예마',
      'tc': '殘虐雜技師',
    },
    'rank': 'B',
  },
  'Keheniheyamewi': {
    'id': '13401',
    'name': {
      'cn': '凯海尼海亚麦尤伊',
      'de': 'Keheniheyamewi',
      'en': 'Keheniheyamewi',
      'fr': 'Keheniheyamewi',
      'ja': 'ケヘニヘヤメウィ',
      'ko': '케헤니헤야메위',
      'tc': '凱海尼海亞麥尤伊',
    },
    'rank': 'A',
  },
  'Ker': {
    'id': '10615',
    'name': {
      'cn': '克尔',
      'de': 'Ker',
      'en': 'Ker',
      'fr': 'Kèr',
      'ja': 'ケール',
      'ko': '케르',
      'tc': '克爾',
    },
    'rank': 'SS+',
  },
  'Ker shroud': {
    'id': '10616',
    'name': {
      'cn': '克尔的侍从',
      'de': 'Diener von Ker',
      'en': 'Ker shroud',
      'fr': 'serviteur de Kèr',
      'ja': 'ケールの従者',
      'ko': '케르의 시종',
      'tc': '克爾的侍從',
    },
    'rank': 'SS-',
  },
  'Kirlirger the Abhorrent': {
    'id': '13360',
    'name': {
      'cn': '厌忌之人 奇里格',
      'de': [
        'Kirlirger der Abscheuliche',
        'Kirlirger der Abscheulicher',
        'Kirlirger der Abscheuliches',
        'Kirlirger die Abscheuliche',
        'Kirlirger die Abscheulicher',
        'Kirlirger die Abscheuliches',
        'Kirlirger das Abscheuliche',
        'Kirlirger das Abscheulicher',
        'Kirlirger das Abscheuliches',
      ],
      'en': 'Kirlirger the Abhorrent',
      'fr': 'Kirlirger l\'abominable',
      'ja': '厭忌のキーリーゲー',
      'ko': '혐오스러운 키리게',
      'tc': '厭忌之人 奇里格',
    },
    'rank': 'S',
  },
  'Kiwa': {
    'id': '6013',
    'name': {
      'cn': '奇洼',
      'de': 'Kiwa',
      'en': 'Kiwa',
      'fr': 'Kiwa',
      'ja': 'キワ',
      'ko': '키와',
      'tc': '奇窪',
    },
    'rank': 'B',
  },
  'Kreutzet': {
    'id': '4351',
    'name': {
      'cn': '克鲁泽',
      'de': 'Kreutzet',
      'en': 'Kreutzet',
      'fr': 'Kreutzet',
      'ja': 'クルーゼ',
      'ko': '크루제',
      'tc': '克魯澤',
    },
    'rank': 'B',
  },
  'Kurma': {
    'id': '6006',
    'name': {
      'cn': '俱利摩',
      'de': 'Kurma',
      'en': 'Kurma',
      'fr': 'Kurma',
      'ja': 'クールマ',
      'ko': '쿠르마',
      'tc': '俱利摩',
    },
    'rank': 'B',
  },
  'Kurrea': {
    'id': '2952',
    'name': {
      'cn': '库雷亚',
      'de': 'Kurrea',
      'en': 'Kurrea',
      'fr': 'Kurrea',
      'ja': 'クーレア',
      'ko': '쿠레아',
      'tc': '庫雷亞',
    },
    'rank': 'A',
  },
  'La Velue': {
    'id': '8908',
    'name': {
      'cn': '浓毛兽',
      'de': 'La Velue',
      'en': 'La Velue',
      'fr': 'Velue',
      'ja': 'ラ・ヴェリュ',
      'ko': '털보오소리',
      'tc': '濃毛獸',
    },
    'rank': 'B',
  },
  'Laideronnette': {
    'id': '2953',
    'name': {
      'cn': '雷德罗巨蛇',
      'de': 'Laideronette',
      'en': 'Laideronnette',
      'fr': 'Laideronnette',
      'ja': 'レドロネット',
      'ko': '레드로네트',
      'tc': '雷德羅巨蛇',
    },
    'rank': 'S',
  },
  'Lampalagua': {
    'id': '2959',
    'name': {
      'cn': '巴拉乌尔',
      'de': 'Balaur',
      'en': 'Lampalagua',
      'fr': 'Balaur',
      'ja': 'バルウール',
      'ko': '발라우르',
      'tc': '巴拉烏爾',
    },
    'rank': 'S',
  },
  'Leafscourge Hadoll Ja': {
    'id': '13148',
    'name': {
      'cn': '绿叶飞花 哈杜加',
      'de': 'Blattgeißel Hadoll Ja',
      'en': 'Leafscourge Hadoll Ja',
      'fr': 'Hadoll Ja le foufeuillu',
      'ja': '緑葉のハドージャ',
      'ko': '푸른잎 하도쟈',
      'tc': '綠葉飛花 哈杜加',
    },
    'rank': 'B',
  },
  'Leech King': {
    'id': '2935',
    'name': {
      'cn': '水蛭王',
      'de': 'Egelkönig',
      'en': 'Leech King',
      'fr': 'roi des sangsues',
      'ja': 'リーチキング',
      'ko': '대왕거머리',
      'tc': '水蛭王',
    },
    'rank': 'B',
  },
  'Leucrotta': {
    'id': '4380',
    'name': {
      'cn': '卢克洛塔',
      'de': 'Leucrotta',
      'en': 'Leucrotta',
      'fr': 'leucrotta',
      'ja': 'レウクロッタ',
      'ko': '레우크로타',
      'tc': '盧克洛塔',
    },
    'rank': 'S',
  },
  'Li\'l Murderer': {
    'id': '8911',
    'name': {
      'cn': '小小杀手',
      'de': [
        'Kleine Mörder',
        'Kleiner Mörder',
        'Kleines Mörder',
      ],
      'en': 'Li\'l Murderer',
      'fr': 'Traître',
      'ja': 'リルマーダー',
      'ko': '작은 살인자',
      'tc': '小小殺手',
    },
    'rank': 'A',
  },
  'Lord of the Wyverns': {
    'id': '4365',
    'name': {
      'cn': '双足飞龙之王',
      'de': 'Wyvern-Lord',
      'en': 'Lord of the Wyverns',
      'fr': 'seigneur des wyvernes',
      'ja': 'ワイバーンロード',
      'ko': '와이번 로드',
      'tc': '雙足飛龍之王',
    },
    'rank': 'A',
  },
  'Luminare': {
    'id': '5995',
    'name': {
      'cn': '泛光晶体',
      'de': 'Luminare',
      'en': 'Luminare',
      'fr': 'Luminare',
      'ja': 'ルミナーレ',
      'ko': '루미나레',
      'tc': '泛光晶體',
    },
    'rank': 'A',
  },
  'Lycidas': {
    'id': '4360',
    'name': {
      'cn': '利西达斯',
      'de': 'Lykidas',
      'en': 'Lycidas',
      'fr': 'Lycidas',
      'ja': 'リュキダス',
      'ko': '류키다스',
      'tc': '利西達斯',
    },
    'rank': 'B',
  },
  'Lyuba': {
    'id': '4363',
    'name': {
      'cn': '卢芭',
      'de': 'Lyuba',
      'en': 'Lyuba',
      'fr': 'Lyuba',
      'ja': 'リューバ',
      'ko': '류바',
      'tc': '盧芭',
    },
    'rank': 'A',
  },
  'Maahes': {
    'id': '2942',
    'name': {
      'cn': '玛赫斯',
      'de': 'Maahes',
      'en': 'Maahes',
      'fr': 'Maahes',
      'ja': 'マヘス',
      'ko': '마헤스',
      'tc': '瑪赫斯',
    },
    'rank': 'A',
  },
  'Mahisha': {
    'id': '5994',
    'name': {
      'cn': '马希沙',
      'de': 'Mahisha',
      'en': 'Mahisha',
      'fr': 'Mahisha',
      'ja': 'マヒシャ',
      'ko': '마히샤',
      'tc': '馬希沙',
    },
    'rank': 'A',
  },
  'Maliktender': {
    'id': '8901',
    'name': {
      'cn': '马利克巨人掌',
      'de': 'Malikkaktor',
      'en': 'Maliktender',
      'fr': 'Malikpampa',
      'ja': 'マリクテンダー',
      'ko': '말리크텐더',
      'tc': '馬利克巨人掌',
    },
    'rank': 'A',
  },
  'Manes': {
    'id': '6012',
    'name': {
      'cn': '玛涅斯',
      'de': 'Manes',
      'en': 'Manes',
      'fr': 'Manes',
      'ja': 'マネス',
      'ko': '마네스',
      'tc': '瑪涅斯',
    },
    'rank': 'B',
  },
  'Marberry': {
    'id': '2949',
    'name': {
      'cn': '玛贝利',
      'de': 'Marberry',
      'en': 'Marberry',
      'fr': 'marberry',
      'ja': 'マーベリー',
      'ko': '마베리',
      'tc': '瑪貝利',
    },
    'rank': 'A',
  },
  'Marraco': {
    'id': '2951',
    'name': {
      'cn': '马拉克',
      'de': 'Marraco',
      'en': 'Marraco',
      'fr': 'Marraco',
      'ja': 'マラク',
      'ko': '머라쿠',
      'tc': '馬拉克',
    },
    'rank': 'A',
  },
  'Melt': {
    'id': '2937',
    'name': {
      'cn': '千眼凝胶',
      'de': 'Schmelze',
      'en': 'Melt',
      'fr': 'Fondu',
      'ja': 'メルティゼリー',
      'ko': '녹아내리는 젤리',
      'tc': '千眼凝膠',
    },
    'rank': 'A',
  },
  'Mindmaker': {
    'id': '8893',
    'name': {
      'cn': '启灵果',
      'de': 'Freigeist',
      'en': 'Mindmaker',
      'fr': 'Maître-penseur',
      'ja': 'マインドメーカー',
      'ko': '지능계발자',
      'tc': '啟靈果',
    },
    'rank': 'B',
  },
  'Minerva': {
    'id': '10627',
    'name': {
      'cn': '密涅瓦',
      'de': 'Minerva',
      'en': 'Minerva',
      'fr': 'Minerva',
      'ja': 'ミネルウァ',
      'ko': '미네르바',
      'tc': '密涅瓦',
    },
    'rank': 'A',
  },
  'Minhocao': {
    'id': '2961',
    'name': {
      'cn': '蚓螈巨虫',
      'de': 'Minhocao',
      'en': 'Minhocao',
      'fr': 'Minhocao',
      'ja': 'ミニョーカオン',
      'ko': '미뇨카온',
      'tc': '蚓螈蠕蟲',
    },
    'rank': 'S',
  },
  'Mirka': {
    'id': '4362',
    'name': {
      'cn': '米勒卡',
      'de': 'Mirka',
      'en': 'Mirka',
      'fr': 'Mirka',
      'ja': 'ミルカ',
      'ko': '미르카',
      'tc': '米勒卡',
    },
    'rank': 'A',
  },
  'Monarch Ogrefly': {
    'id': '2921',
    'name': {
      'cn': '君王鬼蜻蜓',
      'de': 'Monarch Ogerlibelle',
      'en': 'Monarch Ogrefly',
      'fr': 'agrion ogre monarque',
      'ja': 'モナーク・オーガフライ',
      'ko': '제왕잠자리',
      'tc': '君王鬼蜻蜓',
    },
    'rank': 'B',
  },
  'Myradrosh': {
    'id': '2932',
    'name': {
      'cn': '米腊德罗斯蜂鸟',
      'de': 'Myradrosh',
      'en': 'Myradrosh',
      'fr': 'Myradrosh',
      'ja': 'ミラドロッシュ',
      'ko': '미라드로시',
      'tc': '米臘德羅斯蜂鳥',
    },
    'rank': 'B',
  },
  'Nahn': {
    'id': '2948',
    'name': {
      'cn': '纳恩',
      'de': 'Nahn',
      'en': 'Nahn',
      'fr': 'Nahn',
      'ja': 'ナン',
      'ko': '난',
      'tc': '納恩',
    },
    'rank': 'A',
  },
  'Nandi': {
    'id': '2966',
    'name': {
      'cn': '南迪',
      'de': 'Nandi',
      'en': 'Nandi',
      'fr': 'Nandi',
      'ja': 'ナンディ',
      'ko': '난디',
      'tc': '南迪',
    },
    'rank': 'S',
  },
  'Nariphon': {
    'id': '8907',
    'name': {
      'cn': '纳里蓬',
      'de': 'Nariphon',
      'en': 'Nariphon',
      'fr': 'Nariphon',
      'ja': 'ナリーポン',
      'ko': '나리폰',
      'tc': '納里蓬',
    },
    'rank': 'A',
  },
  'Narrow-rift': {
    'id': '10622',
    'name': {
      'cn': '狭缝',
      'de': 'Enger Riss',
      'en': 'Narrow-rift',
      'fr': 'Rift-étroit',
      'ja': 'ナロー＝リフト',
      'ko': '내로 리프트',
      'tc': '狹縫',
    },
    'rank': 'S',
  },
  'Naul': {
    'id': '2934',
    'name': {
      'cn': '纳乌尔',
      'de': 'Naul',
      'en': 'Naul',
      'fr': 'Naul',
      'ja': 'ナウル',
      'ko': '나울',
      'tc': '納烏爾',
    },
    'rank': 'B',
  },
  'Nechuciho': {
    'id': '13362',
    'name': {
      'cn': '内丘奇霍',
      'de': 'Nechuciho',
      'en': 'Nechuciho',
      'fr': 'Nechukiho',
      'ja': 'ネチュキホ',
      'ko': '네추키호',
      'tc': '內丘奇霍',
    },
    'rank': 'A',
  },
  'Neyoozoteel': {
    'id': '12754',
    'name': {
      'cn': '内尤佐缇',
      'de': 'Neyoozoteel',
      'en': 'Neyoozoteel',
      'fr': 'Neyozzoteel',
      'ja': 'ネヨーゾテール',
      'ko': '네요조텔',
      'tc': '內尤佐緹',
    },
    'rank': 'S',
  },
  'Nuckelavee': {
    'id': '8906',
    'name': {
      'cn': '纳克拉维',
      'de': 'Nuckelavee',
      'en': 'Nuckelavee',
      'fr': 'Nuckelavee',
      'ja': 'ナックラヴィー',
      'ko': '너클라비',
      'tc': '納克拉維',
    },
    'rank': 'A',
  },
  'Nunyunuwi': {
    'id': '2960',
    'name': {
      'cn': '努纽努维',
      'de': 'Nunyunuwi',
      'en': 'Nunyunuwi',
      'fr': 'Nunyunuwi',
      'ja': 'ヌニュヌウィ',
      'ko': '느뉴느위',
      'tc': '努紐努維',
    },
    'rank': 'S',
  },
  'O Poorest Pauldia': {
    'id': '8655',
    'name': {
      'cn': '保尔迪雅',
      'de': [
        'gepeinigte Pauldia',
        'gepeinigter Pauldia',
        'gepeinigtes Pauldia',
      ],
      'en': 'O Poorest Pauldia',
      'fr': 'Pauldia',
      'ja': 'ポールディア',
      'ko': '폴디아',
      'tc': '保爾迪雅',
    },
    'rank': 'A',
  },
  'Okina': {
    'id': '5984',
    'name': {
      'cn': '巨大鳐',
      'de': 'Okina',
      'en': 'Okina',
      'fr': 'Okina',
      'ja': 'オキナ',
      'ko': '오키나',
      'tc': '巨大魟',
    },
    'rank': 'S',
  },
  'Omni': {
    'id': '4361',
    'name': {
      'cn': '全能机甲',
      'de': 'Omni',
      'en': 'Omni',
      'fr': 'Omni',
      'ja': 'オムニ',
      'ko': '옴니',
      'tc': '全能機甲',
    },
    'rank': 'B',
  },
  'Oni Yumemi': {
    'id': '5997',
    'name': {
      'cn': '鬼观梦',
      'de': 'Oni Yumemi',
      'en': 'Oni Yumemi',
      'fr': 'Oni Yumemi',
      'ja': 'オニユメミ',
      'ko': '귀신 꿈고둥',
      'tc': '鬼觀夢',
    },
    'rank': 'A',
  },
  'Ophioneus': {
    'id': '10621',
    'name': {
      'cn': '俄菲翁尼厄斯',
      'de': 'Ophioneus',
      'en': 'Ophioneus',
      'fr': 'Ophioneus',
      'ja': 'オピオネウス',
      'ko': '오피오네우스',
      'tc': '俄菲翁尼厄斯',
    },
    'rank': 'S',
  },
  'Orcus': {
    'id': '5990',
    'name': {
      'cn': '奥迦斯',
      'de': 'Orcus',
      'en': 'Orcus',
      'fr': 'Orcus',
      'ja': 'オルクス',
      'ko': '오르쿠스',
      'tc': '奧迦斯',
    },
    'rank': 'A',
  },
  'Orghana': {
    'id': '5986',
    'name': {
      'cn': '兀鲁忽乃朝鲁',
      'de': 'Orghana',
      'en': 'Orghana',
      'fr': 'Orghana',
      'ja': 'オルガナ',
      'ko': '오르가나',
      'tc': '兀魯忽乃朝魯',
    },
    'rank': 'S',
  },
  'Oskh Rhei': {
    'id': '10646',
    'name': {
      'cn': '欧斯克·雷伊',
      'de': 'Oskh Rhei',
      'en': 'Oskh Rhei',
      'fr': 'Oskh Rhei',
      'ja': 'オスク・レイ',
      'ko': '오스크 레이',
      'tc': '歐斯克·雷伊',
    },
    'rank': 'B',
  },
  'Ouzelum': {
    'id': '6009',
    'name': {
      'cn': '奥祖鲁姆',
      'de': 'Ouzelum',
      'en': 'Ouzelum',
      'fr': 'Ouzelum',
      'ja': 'オゼルム',
      'ko': '오젤룸',
      'tc': '奧祖魯姆',
    },
    'rank': 'B',
  },
  'Ovjang': {
    'id': '2924',
    'name': {
      'cn': '奥弗杰恩',
      'de': 'Ovjang',
      'en': 'Ovjang',
      'fr': 'Ovjang',
      'ja': 'アヴゼン',
      'ko': '아브젱',
      'tc': '奧弗杰恩',
    },
    'rank': 'B',
  },
  'Pachamama': {
    'id': '8894',
    'name': {
      'cn': '帕查玛玛',
      'de': 'Pachamama',
      'en': 'Pachamama',
      'fr': 'Pachamama',
      'ja': 'パチャママ',
      'ko': '파차마마',
      'tc': '帕查瑪瑪',
    },
    'rank': 'B',
  },
  'Phecda': {
    'id': '2922',
    'name': {
      'cn': '天玑巨熊',
      'de': 'Phecda',
      'en': 'Phecda',
      'fr': 'Phecda',
      'ja': 'フェクダ',
      'ko': '페크다',
      'tc': '天璣巨熊',
    },
    'rank': 'B',
  },
  'Pkuucha': {
    'id': '13443',
    'name': {
      'cn': '普库恰',
      'de': 'Pkuucha',
      'en': 'Pkuucha',
      'fr': 'Pkuucha',
      'ja': 'プクーチャ',
      'ko': '프쿠차',
      'tc': '普庫恰',
    },
    'rank': 'A',
  },
  'Pterygotus': {
    'id': '4354',
    'name': {
      'cn': '翼肢鲎',
      'de': 'Pterygotus',
      'en': 'Pterygotus',
      'fr': 'Pterygotus',
      'ja': 'プテリゴトゥス',
      'ko': '프테리고투스',
      'tc': '翼肢鱟',
    },
    'rank': 'B',
  },
  'Pylraster': {
    'id': '4364',
    'name': {
      'cn': '派拉斯特暴龙',
      'de': 'Xhauron',
      'en': 'Pylraster',
      'fr': 'Pirlasta',
      'ja': 'パイルラスタ',
      'ko': '파일라스터',
      'tc': '派拉斯特暴龍',
    },
    'rank': 'A',
  },
  'Rrax Yity\'a': {
    'id': '12753',
    'name': {
      'cn': '血鸣鼠',
      'de': 'Rrax Yity\'a',
      'en': 'Rrax Yity\'a',
      'fr': 'Rrax Yity\'a',
      'ja': 'ラシュイチャ',
      'ko': '라슈이챠',
      'tc': '血鳴鼠',
    },
    'rank': 'A',
  },
  'Ruminator': {
    'id': '10620',
    'name': {
      'cn': '沉思之物',
      'de': 'Grübler',
      'en': 'Ruminator',
      'fr': 'ruminateur',
      'ja': 'ルミネイター',
      'ko': '되새기는 자',
      'tc': '沉思之物',
    },
    'rank': 'S',
  },
  'Rusalka': {
    'id': '8896',
    'name': {
      'cn': '卢莎卡',
      'de': 'Rusalka',
      'en': 'Rusalka',
      'fr': 'Roussalka',
      'ja': 'ルサルカ',
      'ko': '루살카',
      'tc': '盧莎卡',
    },
    'rank': 'A',
  },
  'Sabotender Bailarina': {
    'id': '2941',
    'name': {
      'cn': '花舞仙人刺',
      'de': 'Sabotender Bailarina',
      'en': 'Sabotender Bailarina',
      'fr': 'pampa ballerine',
      'ja': 'サボテンダー・バイラリーナ',
      'ko': '사보텐더 무희',
      'tc': '花舞仙人掌怪',
    },
    'rank': 'A',
  },
  'Safat': {
    'id': '2968',
    'name': {
      'cn': '萨法特',
      'de': 'Safat',
      'en': 'Safat',
      'fr': 'Safat',
      'ja': 'サファト',
      'ko': '사파트',
      'tc': '薩法特',
    },
    'rank': 'S',
  },
  'Sally the Sweeper': {
    'id': '13435',
    'name': {
      'cn': '清扫者萨莉',
      'de': [
        'Sally der Fegerin',
        'Sally die Fegerin',
        'Sally das Fegerin',
      ],
      'en': 'Sally the Sweeper',
      'fr': 'Sally la balayeuse',
      'ja': 'サリー・ザ・スイーパー',
      'ko': '청소부 샐리',
      'tc': '清掃者薩莉',
    },
    'rank': 'A',
  },
  'Salt and Light': {
    'id': '5989',
    'name': {
      'cn': '盐和光',
      'de': 'Salzlicht',
      'en': 'Salt and Light',
      'fr': 'Salaclux',
      'ja': 'ソルト・アンド・ライト',
      'ko': '빛과 소금',
      'tc': '鹽和光',
    },
    'rank': 'S',
  },
  'Sansheya': {
    'id': '13399',
    'name': {
      'cn': '山谢亚',
      'de': 'Sansheya',
      'en': 'Sansheya',
      'fr': 'Sansheya',
      'ja': 'サンシェヤ',
      'ko': '산셰야',
      'tc': '山謝亞',
    },
    'rank': 'S',
  },
  'Sanu Vali of Dancing Wings': {
    'id': '4359',
    'name': {
      'cn': '飞舞翼 萨努瓦力',
      'de': [
        'Sanu Vali der Tanzende Schwinge',
        'Sanu Vali der Tanzender Schwinge',
        'Sanu Vali der Tanzendes Schwinge',
        'Sanu Vali die Tanzende Schwinge',
        'Sanu Vali die Tanzender Schwinge',
        'Sanu Vali die Tanzendes Schwinge',
        'Sanu Vali das Tanzende Schwinge',
        'Sanu Vali das Tanzender Schwinge',
        'Sanu Vali das Tanzendes Schwinge',
      ],
      'en': 'Sanu Vali of Dancing Wings',
      'fr': 'Sanu Vali',
      'ja': '舞手のサヌバリ',
      'ko': '무용수 사누발리',
      'tc': '飛舞翼 薩努瓦力',
    },
    'rank': 'B',
  },
  'Scitalis': {
    'id': '4356',
    'name': {
      'cn': '斯奇塔利斯',
      'de': 'Scitalis',
      'en': 'Scitalis',
      'fr': 'Scitalis',
      'ja': 'スキタリス',
      'ko': '스키탈리스',
      'tc': '斯奇塔利斯',
    },
    'rank': 'B',
  },
  'Senmurv': {
    'id': '4375',
    'name': {
      'cn': '神穆尔鸟',
      'de': 'Simurgh',
      'en': 'Senmurv',
      'fr': 'Sênmurw',
      'ja': 'セーンムルウ',
      'ko': '센무르',
      'tc': '神莫爾鳥',
    },
    'rank': 'S',
  },
  'Sewer Syrup': {
    'id': '2923',
    'name': {
      'cn': '阴沟毒液',
      'de': 'Abwasser-Sirup',
      'en': 'Sewer Syrup',
      'fr': 'Syrop d\'égout',
      'ja': 'スェアーシロップ',
      'ko': '하수도 시럽',
      'tc': '陰溝毒液',
    },
    'rank': 'B',
  },
  'Shadow-dweller Yamini': {
    'id': '6008',
    'name': {
      'cn': '影中暗 雅弥尼',
      'de': 'Schattenkauer-Yamini',
      'en': 'Shadow-dweller Yamini',
      'fr': 'Yamini la Nocturne',
      'ja': '宵闇のヤミニ',
      'ko': '땅거미의 야미니',
      'tc': '影中暗 雅彌尼',
    },
    'rank': 'B',
  },
  'Shockmaw': {
    'id': '10644',
    'name': {
      'cn': '肖科莫',
      'de': 'Schockschlund',
      'en': 'Shockmaw',
      'fr': 'choc-gueule',
      'ja': 'ショックモー',
      'ko': '아귀고래',
      'tc': '肖科莫',
    },
    'rank': 'B',
  },
  'Sisiutl': {
    'id': '4371',
    'name': {
      'cn': '西斯尤',
      'de': 'Sisiutl',
      'en': 'Sisiutl',
      'fr': 'Sisiutl',
      'ja': 'シシウトゥル',
      'ko': '시시우틀',
      'tc': '西斯尤',
    },
    'rank': 'A',
  },
  'Skogs Fru': {
    'id': '2928',
    'name': {
      'cn': '花林女郎',
      'de': 'Skogs Fru',
      'en': 'Skogs Fru',
      'fr': 'Skogs Fru',
      'ja': 'スコッグ・フリュー',
      'ko': '스콕스프루',
      'tc': '花林女郎',
    },
    'rank': 'B',
  },
  'Slipkinx Steeljoints': {
    'id': '4366',
    'name': {
      'cn': '机工兵 斯利普金克斯',
      'de': 'Rutschfix Stahlscharnier',
      'en': 'Slipkinx Steeljoints',
      'fr': 'Slipkinx Joints-d\'acier',
      'ja': '機兵のスリップキンクス',
      'ko': '기계병정 슬립킨크스',
      'tc': '機工兵 斯利普金克斯',
    },
    'rank': 'A',
  },
  'Sphatika': {
    'id': '10618',
    'name': {
      'cn': '颇胝迦',
      'de': 'Sphatika',
      'en': 'Sphatika',
      'fr': 'Sphatika',
      'ja': 'スパティカ',
      'ko': '스파티카',
      'tc': '頗胝迦',
    },
    'rank': 'S',
  },
  'Squonk': {
    'id': '4358',
    'name': {
      'cn': '斯奎克',
      'de': 'Squonk',
      'en': 'Squonk',
      'fr': 'Squonk',
      'ja': 'スクオンク',
      'ko': '스퀑크',
      'tc': '斯奎克',
    },
    'rank': 'B',
  },
  'Starcrier': {
    'id': '12692',
    'name': {
      'cn': '幻煌鸟',
      'de': 'Sternschreier',
      'en': 'Starcrier',
      'fr': 'furopluminescent',
      'ja': '幻煌鳥',
      'ko': '환황조',
      'tc': '幻煌鳥',
    },
    'rank': 'A',
  },
  'Stinging Sophie': {
    'id': '2920',
    'name': {
      'cn': '击刺魔蜂索菲',
      'de': [
        'Stinkige Sophie',
        'Stinkiger Sophie',
        'Stinkiges Sophie',
      ],
      'en': 'Stinging Sophie',
      'fr': 'Sophie la dardante',
      'ja': 'スティンギング・ソフィー',
      'ko': '따끔한 소피',
      'tc': '擊刺魔蜂索菲',
    },
    'rank': 'B',
  },
  'Stolas': {
    'id': '4367',
    'name': {
      'cn': '斯特拉斯',
      'de': 'Stolas',
      'en': 'Stolas',
      'fr': 'Stolas',
      'ja': 'ストラス',
      'ko': '스톨라스',
      'tc': '斯特拉斯',
    },
    'rank': 'A',
  },
  'Storsie': {
    'id': '10623',
    'name': {
      'cn': '斯图希',
      'de': 'Storsie',
      'en': 'Storsie',
      'fr': 'Storsie',
      'ja': 'ストーシー',
      'ko': '스토르시에',
      'tc': '斯圖希',
    },
    'rank': 'A',
  },
  'Sugaar': {
    'id': '8902',
    'name': {
      'cn': '休格尔',
      'de': 'Sugaar',
      'en': 'Sugaar',
      'fr': 'Sugaar',
      'ja': 'シュガール',
      'ko': '슈가르',
      'tc': '休格爾',
    },
    'rank': 'A',
  },
  'Sugriva': {
    'id': '10626',
    'name': {
      'cn': '须羯里婆',
      'de': 'Sugriva',
      'en': 'Sugriva',
      'fr': 'Sugriva',
      'ja': 'スグリーヴァ',
      'ko': '수그리바',
      'tc': '須羯里婆',
    },
    'rank': 'A',
  },
  'Sum': {
    'id': '6001',
    'name': {
      'cn': '硕姆',
      'de': 'Sum',
      'en': 'Sum',
      'fr': 'Sum',
      'ja': 'ソム',
      'ko': '솜',
      'tc': '碩姆',
    },
    'rank': 'A',
  },
  'Supay': {
    'id': '8891',
    'name': {
      'cn': '苏帕伊',
      'de': 'Supay',
      'en': 'Supay',
      'fr': 'Supay',
      'ja': 'スペイ',
      'ko': '수파이',
      'tc': '蘇帕伊',
    },
    'rank': 'A',
  },
  'Tarchia': {
    'id': '8900',
    'name': {
      'cn': '多智兽',
      'de': 'Tarchia',
      'en': 'Tarchia',
      'fr': 'Tarchia',
      'ja': 'タルキア',
      'ko': '타르키아',
      'tc': '多智獸',
    },
    'rank': 'S',
  },
  'Thextera': {
    'id': '4353',
    'name': {
      'cn': '提克斯塔',
      'de': 'Dexter',
      'en': 'Thextera',
      'fr': 'Texta',
      'ja': 'テクスタ',
      'ko': '텍스타',
      'tc': '提克斯塔',
    },
    'rank': 'B',
  },
  'Thousand-cast Theda': {
    'id': '2956',
    'name': {
      'cn': '千竿口花希达',
      'de': 'Tausendzahn Theda',
      'en': 'Thousand-cast Theda',
      'fr': 'Theda la tripoteuse',
      'ja': 'サウザンドキャスト・セダ',
      'ko': '천갈래덩굴 세다',
      'tc': '千竿食腐獸希達',
    },
    'rank': 'S',
  },
  'Tyger': {
    'id': '8905',
    'name': {
      'cn': '戾虫',
      'de': 'Tyger',
      'en': 'Tyger',
      'fr': 'Tygre',
      'ja': 'ティガー',
      'ko': '티거',
      'tc': '戾蟲',
    },
    'rank': 'S',
  },
  'Udumbara': {
    'id': '5987',
    'name': {
      'cn': '优昙婆罗花',
      'de': 'Udumbara',
      'en': 'Udumbara',
      'fr': 'Udumbara',
      'ja': 'ウドンゲ',
      'ko': '우담바라',
      'tc': '優曇婆羅花',
    },
    'rank': 'S',
  },
  'Uktena': {
    'id': '13151',
    'name': {
      'cn': '乌克提纳',
      'de': 'Uktena',
      'en': 'Uktena',
      'fr': 'Uktena',
      'ja': 'ウクテナ',
      'ko': '우크테나',
      'tc': '烏克提納',
    },
    'rank': 'B',
  },
  'Unktehi': {
    'id': '2946',
    'name': {
      'cn': '乌克提希',
      'de': 'Unktehi',
      'en': 'Unktehi',
      'fr': 'Unktehi',
      'ja': 'ウンクテヒ',
      'ko': '웅크테히',
      'tc': '烏克提希',
    },
    'rank': 'A',
  },
  'Urna Variabilis': {
    'id': '13158',
    'name': {
      'cn': '多变装置',
      'de': 'Urna Variabilis',
      'en': 'Urna Variabilis',
      'fr': 'pod variant',
      'ja': 'ヴァリアポッド',
      'ko': '가변 항아리',
      'tc': '多變裝置',
    },
    'rank': 'A',
  },
  'Vajrakumara': {
    'id': '10637',
    'name': {
      'cn': '金刚鸠摩罗',
      'de': 'Vajrakumara',
      'en': 'Vajrakumara',
      'fr': 'vajrakumara',
      'ja': 'ヴァジュラクマーラ',
      'ko': '바즈라쿠마라',
      'tc': '金剛鳩摩羅',
    },
    'rank': 'B',
  },
  'Vochstein': {
    'id': '5992',
    'name': {
      'cn': '弗克施泰因',
      'de': 'Vochstein',
      'en': 'Vochstein',
      'fr': 'Vochstein',
      'ja': 'バックスタイン',
      'ko': '보크스타인',
      'tc': '弗克施泰因',
    },
    'rank': 'A',
  },
  'Vogaal Ja': {
    'id': '2945',
    'name': {
      'cn': '丑男子 沃迦加',
      'de': 'Vogaal Ja',
      'en': 'Vogaal Ja',
      'fr': 'Vogaal Ja',
      'ja': '醜男のヴォガージャ',
      'ko': '못생긴 보가쟈',
      'tc': '醜男子 沃迦加',
    },
    'rank': 'A',
  },
  'Vulpangue': {
    'id': '8657',
    'name': {
      'cn': '狐首虺',
      'de': 'Vulpangue',
      'en': 'Vulpangue',
      'fr': 'Vulpangue',
      'ja': 'ヴルパングエ',
      'ko': '불팡구에',
      'tc': '狐首虺',
    },
    'rank': 'B',
  },
  'Vuokho': {
    'id': '2933',
    'name': {
      'cn': '巫刻猎鹫',
      'de': 'Vuokho',
      'en': 'Vuokho',
      'fr': 'Vuokho',
      'ja': 'ヴオコー',
      'ko': '부오코',
      'tc': '巫刻獵鷲',
    },
    'rank': 'B',
  },
  'White Joker': {
    'id': '2919',
    'name': {
      'cn': '白鬼鼠王',
      'de': [
        'Weiße Joker',
        'Weißer Joker',
        'Weißes Joker',
      ],
      'en': 'White Joker',
      'fr': 'joker blanc',
      'ja': 'ホワイトジョーカー',
      'ko': '흰재간둥이',
      'tc': '白鬼鼠王',
    },
    'rank': 'B',
  },
  'Worm of the Well': {
    'id': '8903',
    'name': {
      'cn': '大井巨虫',
      'de': 'Wurm des Brunnens',
      'en': 'Worm of the Well',
      'fr': 'Verpuy',
      'ja': 'ウェルウォーム',
      'ko': '우물지렁이',
      'tc': '大井蠕蟲',
    },
    'rank': 'B',
  },
  'Wulgaru': {
    'id': '2954',
    'name': {
      'cn': '乌尔伽鲁',
      'de': 'Wulgaru',
      'en': 'Wulgaru',
      'fr': 'Wulgaru',
      'ja': 'ウルガル',
      'ko': '울가루',
      'tc': '烏爾伽魯',
    },
    'rank': 'S',
  },
  'Xty\'iinbek': {
    'id': '13149',
    'name': {
      'cn': '休提因别克',
      'de': 'Xty\'iinbek',
      'en': 'Xty\'iinbek',
      'fr': 'xty\'iinbek',
      'ja': 'シュティーンベク',
      'ko': '슈틴베크',
      'tc': '休提因別克',
    },
    'rank': 'B',
  },
  'Yehehetoaua\'pyo': {
    'id': '13400',
    'name': {
      'cn': '艾海海陶瓦泡',
      'de': 'Yehehetoaua\'pyo',
      'en': 'Yehehetoaua\'pyo',
      'fr': 'Yehehetoaua\'pyo',
      'ja': 'エヘヘトーワポ',
      'ko': '예헤헤토와포',
      'tc': '艾海海陶瓦泡',
    },
    'rank': 'A',
  },
  'Yilan': {
    'id': '10625',
    'name': {
      'cn': '尤兰',
      'de': 'Yilan',
      'en': 'Yilan',
      'fr': 'yilan',
      'ja': 'ユラン',
      'ko': '윌란',
      'tc': '尤蘭',
    },
    'rank': 'A',
  },
  'Yumcax': {
    'id': '10643',
    'name': {
      'cn': '尤姆卡克斯',
      'de': 'Yumcax',
      'en': 'Yumcax',
      'fr': 'Yumcax',
      'ja': 'ユムカクス',
      'ko': '윰칵스',
      'tc': '尤姆卡克斯',
    },
    'rank': 'B',
  },
  'Zanig\'oh': {
    'id': '2943',
    'name': {
      'cn': '札尼戈',
      'de': 'Zanig\'oh',
      'en': 'Zanig\'oh',
      'fr': 'Zanig\'oh',
      'ja': 'ザニゴ',
      'ko': '자니고',
      'tc': '札尼戈',
    },
    'rank': 'A',
  },
  'Zona Seeker': {
    'id': '2957',
    'name': {
      'cn': '虚无探索者',
      'de': 'Zona Sucher',
      'en': 'Zona Seeker',
      'fr': 'Zona Seeker',
      'ja': 'ゾーナ・シーカー',
      'ko': '조나 시커',
      'tc': '虛無探索者',
    },
    'rank': 'S',
  },
  'arch aethereater': {
    'id': '13406',
    'name': {
      'cn': '水晶化身之王',
      'de': 'Herr der Kristallisation',
      'en': 'arch aethereater',
      'fr': 'seigneur des cristallisateurs',
      'ja': 'ロード・オブ・クリスタライザー',
      'ko': '크리스탈라이저 군주',
      'tc': '水晶化身之王',
    },
    'rank': 'SS+',
  },
  'crystal incarnation': {
    'id': '13407',
    'name': {
      'cn': '水晶化身',
      'de': [
        'inkarnierte Kristallisation',
        'inkarnierter Kristallisation',
        'inkarniertes Kristallisation',
      ],
      'en': 'crystal incarnation',
      'fr': 'cristallisateur',
      'ja': 'クリスタライザー',
      'ko': '크리스탈라이저',
      'tc': '水晶化身',
    },
    'rank': 'SS-',
  },
  'daphnia magna': {
    'id': '10641',
    'name': {
      'cn': '巨月蚤',
      'de': 'Daphnia Magna',
      'en': 'daphnia magna',
      'fr': 'magna daphnie',
      'ja': 'ダフニアマグナ',
      'ko': '거대 물벼룩',
      'tc': '巨月蚤',
    },
    'rank': 'B',
  },
  'false gigantopithecus': {
    'id': '4355',
    'name': {
      'cn': '布拉巨猿',
      'de': 'Gigantopithecus',
      'en': 'false gigantopithecus',
      'fr': 'gigantopithèque',
      'ja': 'ブラクキ',
      'ko': '기간토피테쿠스',
      'tc': '布拉巨猿',
    },
    'rank': 'B',
  },
  'forgiven gossip': {
    'id': '8916',
    'name': {
      'cn': '得到宽恕的流言',
      'de': [
        'geläuterte Lästerei',
        'geläuterter Lästerei',
        'geläutertes Lästerei',
      ],
      'en': 'forgiven gossip',
      'fr': 'médisance pardonnée',
      'ja': 'フォーギヴン・ゴシップ',
      'ko': '면죄된 험담',
      'tc': '得到寬恕的流言',
    },
    'rank': 'SS-',
  },
  'forgiven pedantry': {
    'id': '8910',
    'name': {
      'cn': '得到宽恕的炫学',
      'de': [
        'geläuterte Pedanterie',
        'geläuterter Pedanterie',
        'geläutertes Pedanterie',
      ],
      'en': 'forgiven pedantry',
      'fr': 'pédanterie pardonnée',
      'ja': 'フォーギヴン・ペダントリー',
      'ko': '면죄된 현학',
      'tc': '得到寬恕的炫學',
    },
    'rank': 'S',
  },
  'forgiven rebellion': {
    'id': '8915',
    'name': {
      'cn': '得到宽恕的叛乱',
      'de': [
        'geläuterte Rebellion',
        'geläuterter Rebellion',
        'geläutertes Rebellion',
      ],
      'en': 'forgiven rebellion',
      'fr': 'rébellion pardonnée',
      'ja': 'フォーギヴン・リベリオン',
      'ko': '면죄된 폭동',
      'tc': '得到寬恕的叛亂',
    },
    'rank': 'SS+',
  },
  'gargant': {
    'id': '13153',
    'name': {
      'cn': '高康特',
      'de': 'Gargant',
      'en': 'gargant',
      'fr': 'gargant',
      'ja': 'ガルガント',
      'ko': '가르간트',
      'tc': '高康特',
    },
    'rank': 'B',
  },
  'genesis rock': {
    'id': '10642',
    'name': {
      'cn': '起源石',
      'de': 'Genesisfels',
      'en': 'genesis rock',
      'fr': 'pierre de la genèse',
      'ja': 'ジェネシスロック',
      'ko': '태초암',
      'tc': '起源石',
    },
    'rank': 'B',
  },
  'go\'ozoabek\'be': {
    'id': '13147',
    'name': {
      'cn': '格沃佐拜柯拜',
      'de': 'Go\'ozoabek\'be',
      'en': 'go\'ozoabek\'be',
      'fr': 'Go\'ozoabek\'be',
      'ja': 'ゴーゾアックベ',
      'ko': '고조악크베',
      'tc': '格沃佐拜柯拜',
    },
    'rank': 'B',
  },
  'green Archon': {
    'id': '10635',
    'name': {
      'cn': '草贤人',
      'de': [
        'grüne Exeget',
        'grüner Exeget',
        'grünes Exeget',
      ],
      'en': 'green Archon',
      'fr': 'Preux feuillu',
      'ja': '草賢人',
      'ko': '풀현인',
      'tc': '草賢人',
    },
    'rank': 'B',
  },
  'heshuala': {
    'id': '13157',
    'name': {
      'cn': '海休瓦拉',
      'de': 'Heshuala',
      'en': 'heshuala',
      'fr': 'heshuala',
      'ja': 'ヘシュワラ',
      'ko': '헤쉬왈라',
      'tc': '海休瓦拉',
    },
    'rank': 'A',
  },
  'hulder': {
    'id': '10624',
    'name': {
      'cn': '胡睹',
      'de': 'Hulder',
      'en': 'hulder',
      'fr': 'huldre',
      'ja': 'フルドラ',
      'ko': '훌드라',
      'tc': '胡睹',
    },
    'rank': 'A',
  },
  'jewel bearer': {
    'id': '13154',
    'name': {
      'cn': '携宝精',
      'de': 'Juwelenträger',
      'en': 'jewel bearer',
      'fr': 'porte-joyaux',
      'ja': 'ジュエルベアラー',
      'ko': '반짝이도둑',
      'tc': '攜寶精',
    },
    'rank': 'B',
  },
  'kaiser behemoth': {
    'id': '4374',
    'name': {
      'cn': '凯撒贝希摩斯',
      'de': 'Kaiser-Behemoth',
      'en': 'kaiser behemoth',
      'fr': 'béhémoth empereur',
      'ja': 'カイザーベヒーモス',
      'ko': '카이저 베히모스',
      'tc': '凱撒凶惡巨獸',
    },
    'rank': 'S',
  },
  'level cheater': {
    'id': '10645',
    'name': {
      'cn': '等级作弊仪',
      'de': 'Stufenschummler',
      'en': 'level cheater',
      'fr': 'tricheniveau',
      'ja': 'レベルチーター',
      'ko': '레벨 교란기',
      'tc': '等級作弊儀',
    },
    'rank': 'B',
  },
  'lunatender queen': {
    'id': '10629',
    'name': {
      'cn': '月面仙人刺女王',
      'de': 'Lunatender-Königin',
      'en': 'lunatender queen',
      'fr': 'pampa sélénienne reine',
      'ja': 'ルナテンダー・クイーン',
      'ko': '루나텐더 여왕',
      'tc': '月面仙人掌怪女王',
    },
    'rank': 'A',
  },
  'mad maguey': {
    'id': '13144',
    'name': {
      'cn': '疯狂龙舌兰',
      'de': [
        'aggressive Agave',
        'aggressiver Agave',
        'aggressives Agave',
      ],
      'en': 'mad maguey',
      'fr': 'pita dément',
      'ja': 'マッドマゲイ',
      'ko': '미친 용설란',
      'tc': '瘋狂龍舌蘭',
    },
    'rank': 'B',
  },
  'mindflayer': {
    'id': '2955',
    'name': {
      'cn': '夺心魔',
      'de': 'Seelenbrenner',
      'en': 'mindflayer',
      'fr': 'flagelleur mental',
      'ja': 'マインドフレア',
      'ko': '정신지배자',
      'tc': '精神吸取者',
    },
    'rank': 'S',
  },
  'mousse princess': {
    'id': '10630',
    'name': {
      'cn': '慕斯公主',
      'de': 'Mousse-Prinzessin',
      'en': 'mousse princess',
      'fr': 'princesse mousse',
      'ja': 'ムースプリンセス',
      'ko': '무스 공주',
      'tc': '慕斯公主',
    },
    'rank': 'A',
  },
  'nopalitender Fabuloso': {
    'id': '13150',
    'name': {
      'cn': '绝妙圆扇刺',
      'de': 'Feigenkaktor Fabuloso',
      'en': 'nopalitender Fabuloso',
      'fr': 'pampa de barbarie fabuleux',
      'ja': 'ノパルテンダー・ファビュローソー',
      'ko': '노팔텐더 멋쟁이',
      'tc': '絕妙圓扇仙人掌怪',
    },
    'rank': 'B',
  },
  'petalodus': {
    'id': '10632',
    'name': {
      'cn': '瓣齿鲨',
      'de': 'Petalodus',
      'en': 'petalodus',
      'fr': 'petalodus',
      'ja': 'ペタロドゥス',
      'ko': '페탈로두스',
      'tc': '瓣齒鯊',
    },
    'rank': 'A',
  },
  'queen hawk': {
    'id': '13361',
    'name': {
      'cn': '女王鹰蜂',
      'de': 'Falkenkönigin',
      'en': 'queen hawk',
      'fr': 'reine des guêpes',
      'ja': 'クイーンホーク',
      'ko': '여왕매벌',
      'tc': '女王鷹蜂',
    },
    'rank': 'A',
  },
  'stench blossom': {
    'id': '4373',
    'name': {
      'cn': '恶臭狂花',
      'de': 'Pestwurz',
      'en': 'stench blossom',
      'fr': 'fleur nauséabonde',
      'ja': 'センチブロッサム',
      'ko': '악취화',
      'tc': '惡臭狂花',
    },
    'rank': 'A',
  },
  'the Forecaster': {
    'id': '13437',
    'name': {
      'cn': '天气预报机器人',
      'de': 'Wetterreporter',
      'en': 'the Forecaster',
      'fr': 'Monsieur météo',
      'ja': 'ウェザーリポーター',
      'ko': '기상예보기',
      'tc': '天氣預報機器人',
    },
    'rank': 'S',
  },
  'the Garlok': {
    'id': '2964',
    'name': {
      'cn': '伽洛克',
      'de': 'Garlok',
      'en': 'the Garlok',
      'fr': 'Garlok',
      'ja': 'ガーロック',
      'ko': '갈록',
      'tc': '伽洛克',
    },
    'rank': 'S',
  },
  'the Pale Rider': {
    'id': '4376',
    'name': {
      'cn': '苍白骑士',
      'de': [
        'Bleiche Reiter',
        'Bleicher Reiter',
        'Bleiches Reiter',
      ],
      'en': 'the Pale Rider',
      'fr': 'Cavalier pâle',
      'ja': 'ペイルライダー',
      'ko': '창백의 기수',
      'tc': '蒼白騎士',
    },
    'rank': 'S',
  },
  'the Raintriller': {
    'id': '13442',
    'name': {
      'cn': '惊雨蟾蜍',
      'de': 'Regentriller',
      'en': 'the Raintriller',
      'fr': 'Trilleur de pluie',
      'ja': 'レイントリラー',
      'ko': '빗물흥얼이',
      'tc': '驚雨蟾蜍',
    },
    'rank': 'A',
  },
  'the Scarecrow': {
    'id': '4357',
    'name': {
      'cn': '惊慌稻草龙',
      'de': 'Tyranno',
      'en': 'the Scarecrow',
      'fr': 'dracosaure primus',
      'ja': 'スケアクロウ',
      'ko': '허수아비전갈',
      'tc': '驚慌稻草龍',
    },
    'rank': 'B',
  },
  'the Slammer': {
    'id': '13146',
    'name': {
      'cn': '撞角头',
      'de': 'Rammkopf',
      'en': 'the Slammer',
      'fr': 'Marteleur',
      'ja': 'ラムヘッド',
      'ko': '충각악어',
      'tc': '撞角頭',
    },
    'rank': 'B',
  },
  'the mudman': {
    'id': '8654',
    'name': {
      'cn': '泥人',
      'de': 'Matschklops',
      'en': 'the mudman',
      'fr': 'tas de boue',
      'ja': '泥人',
      'ko': '진흙인간',
      'tc': '泥人',
    },
    'rank': 'A',
  },
  'warmonger': {
    'id': '10639',
    'name': {
      'cn': '战争贩子',
      'de': 'Kriegstreiber',
      'en': 'warmonger',
      'fr': 'Belliciste',
      'ja': 'ウォーモンガー',
      'ko': '전쟁광',
      'tc': '戰爭販子',
    },
    'rank': 'B',
  },
  'ü-u-ü-u': {
    'id': '10636',
    'name': {
      'cn': '哞哞',
      'de': 'Ü-u-ü-u',
      'en': 'ü-u-ü-u',
      'fr': 'Ü-u-ü-u',
      'ja': 'ウーヴウーヴ',
      'ko': '우후우후',
      'tc': '哞哞',
    },
    'rank': 'B',
  },
};

export default data;
